/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./settings-row.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./settings-row.component";
var styles_SettingsRowComponent = [i0.styles];
var RenderType_SettingsRowComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_SettingsRowComponent, data: {} });
export { RenderType_SettingsRowComponent as RenderType_SettingsRowComponent };
export function View_SettingsRowComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_SettingsRowComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-settings-row", [], null, null, null, View_SettingsRowComponent_0, RenderType_SettingsRowComponent)), i1.ɵdid(1, 114688, null, 0, i2.SettingsRowComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SettingsRowComponentNgFactory = i1.ɵccf("cc-settings-row", i2.SettingsRowComponent, View_SettingsRowComponent_Host_0, {}, {}, ["*"]);
export { SettingsRowComponentNgFactory as SettingsRowComponentNgFactory };
